import { StyleSheet } from 'aphrodite';
import { borderColor } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		minHeight: '100%',
		width: '100%',
	},
	header: {
		backgroundColor: '#F9F9F9',
		borderBottom: `2px solid ${borderColor}`,
	},
	body: {
		alignItems: 'center',
	},
	footer: {},
	surveyContent: {},
	unavailable: {},
});
